import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Button, Card, Col, Form, Icon, notification, Row, Typography } from 'antd'
import { Formik } from 'formik'
import { get } from 'lodash'

import { Creators as LoadingActions } from '../../appRedux/ducks/loading'
import { CustomBreadcrumb } from '../../components/CustomBreadcrumb/CustomBreadcrumb'
import CustomInput from '../../components/CustomInput/customInput'
import CustomMap from '../../components/CustomMap/customMap'
import CustomSelect from '../../components/CustomSelect/customSelect'
import CustomSwitch from '../../components/CustomSwitch/customSwitch'
import FormHeader from '../../components/FormHeader/FormHeader'
import injectValidationMethods from '../../util/checkValidation'
import { api, request } from '../../util/handlerRequestUtil'
import { getMessage } from '../../util/IntlMessages'
import PasswordPopover from '../Login/PasswordPopover'
import { CreateFormValidations, UpdateFormValidations } from './MemberValidation'
import { RULES, validRule } from '../../constants/Entitlements'
import { isAdmin } from '../../util/profiles'
const CreateMember = function ({ match, history }) {
  // Formaters select
  const [formatedCities, setFormatedCities] = useState([])
  const [formattedStates, setFormattedStates] = useState([])
  const [formattedOrganizations, setFormattedOrganizations] = useState([])
  const [formattedRegions, setFormattedRegions] = useState([])
  const [formattedDistricts, setFormattedDistricts] = useState([])
  const [documentType, setDocumentType] = useState([])
  const [documentTypeAll, setDocumentTypeAll] = useState([])
  const [formatedMemberTypes, setFormatedMemberTypes] = useState([])
  const [formatedProfiles, setFormatedProfiles] = useState([])
  const [documentTypeMask, setDocumentTypeMask] = useState('')
  const dispatch = useDispatch()
  // Map
  const [mapLatitude, setMapLatitude] = useState(undefined)
  const [mapLongitude, setMapLongitude] = useState(undefined)
  const [mapZoom, setMapZoom] = useState(undefined)

  const { id } = match.params
  const [formValues, setFormValues] = useState({ active: true })
  const currentUser = useSelector((state) => state.auth.auth)
  const isCurrentUserAdmin = isAdmin(currentUser)

  const form = {
    initialValues: formValues,
    validationSchema: id ? UpdateFormValidations(isCurrentUserAdmin) : CreateFormValidations(isCurrentUserAdmin),
    onSubmit: async (values) => {
      console.tron.log('submit values', values)

      const coordinates = `${get(values, 'maps.lat', 0)},${get(values, 'maps.long', 0)}`

      if (values.coordinates === 'undefined,undefined') {
        values.coordinates = null
      }

      const data = {
        name: values.name,
        userId: +values.userId || null,
        phoneNumber: values.phoneNumber,
        emailAddress: values.emailAddress,
        principalMember: true,
        parentMemberId: values.parentMemberId,
        documentNumber: values.documentNumber,
        documentTypeId: +values.documentTypeId,
        addressDescription: values.addressDescription,
        addressNumber: values.addressNumber,
        addressComplement: values.addressComplement,
        neighborhood: values.neighborhood,
        zipCode: values.zipCode,
        cityStateId: values.cityStateId,
        externalPk: values.externalPk,
        customersApproved: values.customersApproved || false,
        organizations: values.organizations,
        regions: values.regions,
        districts: values.districts || [],
        active: values.active,
        coordinates,
        memberTypeId: values.memberTypeId,
        user: values.allowToLogin
          ? {
              active: values.allowToLogin,
              profileId: values.profileId,
              userLogin: values.emailAddress,
              userPassword: values.password
            }
          : null
      }

      if (!id) {
        storeMember(data)
      } else {
        const payload = {
          id,
          data
        }
        updateMember(payload)
      }
    }
  }

  // Mount/Umount component
  useEffect(() => {
    const hasAccess = validRule(RULES.MEMBER) // Não deixa acessar a tela
    if (!hasAccess) {
      return history.push('/home')
    }

    if (id) {
      retrieveMember(id)
    } else {
      setFormValues({
        ...formValues,
        'maps.lat': mapLatitude,
        'maps.long': mapLongitude,
        'maps.zoom': mapZoom,
        coordinates: `${mapLatitude},${mapLongitude}`
      })
    }

    fetchData()
  }, [])

  async function fetchData() {
    try {
      dispatch(LoadingActions.openLoading())
      await listStatesDropdown({ active: true })
      await listMemberTypes({ active: true })
      await listProfilesDropDown()
      await listDocumentType()
      if (isCurrentUserAdmin) {
        await listOrganizations()
      }
    } catch (error) {
      console.tron.log(error)
    } finally {
      dispatch(LoadingActions.closeLoading())
    }
  }

  useEffect(() => {
    console.tron.log('values.states', formValues.state)
    if (formValues.state) {
      listCities({
        stateAbbreviation: formValues.state,
        active: true
      })
    }
  }, [formValues.state])

  useEffect(() => {
    console.tron.log('values.zipCode', formValues.zipCode)
    if (
      formValues.zipCode &&
      formValues.zipCode.length === 9 &&
      formValues.zipCode[formValues.zipCode.length - 1] !== '_'
    ) {
      getCepData(formValues.zipCode)
      dispatch(LoadingActions.openLoading())
    }

    return () => {
      LoadingActions.closeLoading()
    }
  }, [formValues.zipCode])

  useEffect(() => {
    const { documentTypeId } = formValues
    if (documentTypeId) {
      const mask = documentTypeAll.find((docType) => docType.id == documentTypeId)
      if (mask && mask.mask) {
        setDocumentTypeMask(mask.mask)
      } else {
        setDocumentTypeMask(null)
      }
    }
  }, [formValues.documentTypeId])

  useEffect(() => {
    if (mapLatitude && mapLongitude && mapZoom) {
      setFormValues({
        ...formValues,
        'maps.lat': mapLatitude,
        'maps.long': mapLongitude,
        'maps.zoom': mapZoom,
        coordinates: `${mapLatitude},${mapLongitude}`
      })
    }
  }, [mapLatitude, mapLongitude, mapZoom])

  // Api requests
  async function storeMember(data) {
    try {
      console.tron.log('storeMember', data)
      await request(api.storeMember(data))
      notification.success({
        description: getMessage('successStoreMember'),
        message: getMessage('sweetAlerts.success')
      })
      setFormValues({})
      history.goBack()
    } catch (error) {
      console.tron.log(error)
    }
  }

  async function retrieveMember(id) {
    try {
      const response = await request(api.retrieveMemberFull(id))
      await retrieveDistrictsByRegions({ regionId: response.regions.map(({ id }) => id), active: true })
      await retrieveRegionsByOrganizationId({
        organizationId: response.organizations.map(({ id }) => id),
        active: true
      })

      await listMemberTypes({ active: true })
      let memberType = []
      const memberHasType = await request(api.listMemberHasTypeByMemberId(response.id))
      memberHasType.map((i) => {
        memberType.push(i.memberTypeId)
      })

      const user = await request(api.getUserById(response.userId))

      const formattedCoords = response.coordinates ? response.coordinates : { x: mapLatitude, y: mapLongitude }
      setTimeout(() => setMapLatitude(formattedCoords.x), 1000)
      setTimeout(() => setMapLongitude(formattedCoords.y), 1000)
      const newMember = {
        ...response,
        organizations: response.organizations.map(({ id }) => id),
        regions: response.regions.map(({ id }) => id),
        districts: response.districts.map(({ id }) => id),
        allowToLogin: user.active,
        memberTypeId: memberType.length > 0 ? memberType : response.memberTypeId,
        user
      }

      setFormValues(newMember)
    } catch (error) {
      console.tron.log(error)
    }
  }

  async function updateMember(payload) {
    try {
      console.tron.log('updateMember', payload)
      const { id, data } = payload
      await request(api.updateMember(Number(id), data))
      notification.success({
        description: getMessage('successUpdateMember'),
        message: getMessage('sweetAlerts.success')
      })
      history.goBack()
    } catch (error) {
      console.tron.log(error)
    }
  }

  async function listOrganizations() {
    const organizations = await request(api.listOrganizationsDropDown({ active: true, todos: false }))
    setFormattedOrganizations(organizations)
  }

  async function listDocumentType() {
    const documentType = await request(api.listDocumentTypeDropDown({ active: true }))
    const documentTypeAll = await request(api.listDocumentType({ active: true }))
    setDocumentType(documentType)
    setDocumentTypeAll(documentTypeAll)
  }

  async function listCities(params) {
    try {
      const response = await request(api.listCitiesDropDown(params))
      setFormatedCities(response)
    } catch (error) {
      console.tron.log(error)
    }
  }

  async function listMemberTypes(params) {
    try {
      const response = await request(api.listMemberTypesDropDown({ ...params, todos: false }))
      setFormatedMemberTypes(response)
    } catch (error) {
      console.tron.log(error)
    }
  }

  async function retrieveRegionsByOrganizationId(params) {
    const regions = await request(api.listRegionDropDown({ ...params, todos: false, active: true }))
    setFormattedRegions(regions)
    return regions || []
  }

  async function retrieveDistrictsByRegions(params) {
    const districts = await request(api.getDistrictsDropdown({ ...params, todos: false, active: true }))
    setFormattedDistricts(districts)
    return districts || []
  }

  async function listProfilesDropDown() {
    try {
      const response = await request(api.listProfilesDropDown({ active: true, todos: false }))
      console.tron.log('response listProfiles', response)

      setFormatedProfiles(response)
    } catch (error) {
      console.tron.log(error)
    }
  }

  async function listStatesDropdown(params) {
    try {
      const response = await request(api.listStates(params))
      console.tron.log('response listStates', response)
      setFormattedStates(response)
    } catch (error) {
      console.tron.log(error)
    }
  }

  async function getCepData(params) {
    try {
      const response = await request(api.getCepData(params))
      setFormValues({
        ...formValues,
        addressDescription: response.logradouro || formValues.addressDescription,
        addressComplement: response.complemento || formValues.addressComplement,
        neighborhood: response.bairro || formValues.neighborhood,
        state: response.uf || formValues.state
      })
      console.tron.log('response getCepData', response)
    } catch (error) {
      console.tron.log(error)
    }
  }

  async function onChangeOrganization(eventValue) {
    if (eventValue.length === 0) {
      setFormValues((prev) => ({ ...prev, regions: [], districts: [], organizations: [] }))
      setFormattedRegions([])
      setFormattedDistricts([])
      return
    }

    let updatedFormValues = {
      organizations: eventValue,
      regions: formValues.regions || [],
      districts: formValues.districts || []
    }

    const regions = await retrieveRegionsByOrganizationId({ organizationId: eventValue })
    updatedFormValues.regions = updatedFormValues.regions.filter((region) =>
      regions.map(({ value }) => value).includes(region)
    )

    if (updatedFormValues.regions.length > 0) {
      const districts = await retrieveDistrictsByRegions({ regionId: updatedFormValues.regions })
      updatedFormValues.districts = updatedFormValues.districts.filter((district) =>
        districts.map(({ value }) => value).includes(district)
      )
    } else {
      updatedFormValues.districts = []
    }

    setFormValues((prev) => ({ ...prev, ...updatedFormValues }))
  }

  async function onChangeRegion(eventValue) {
    if (eventValue.length === 0) {
      setFormValues((prev) => ({ ...prev, districts: [], regions: [] }))
      setFormattedDistricts([])
      return
    }

    const districts = await retrieveDistrictsByRegions({ regionId: eventValue })
    const selectedDistricts = (formValues.districts || []).filter((district) =>
      districts.map(({ value }) => value).includes(district)
    )

    setFormValues((prev) => ({
      ...prev,
      regions: eventValue,
      districts: selectedDistricts
    }))
  }

  function getTitle() {
    return id !== undefined ? getMessage('updateMember') : getMessage('createMember')
  }

  function renderHeader(submitForm) {
    const hasAccess = validRule(RULES.MEMBER)

    return (
      <div className="default-header-div">
        <div className="default-header-breadcrumb">
          <CustomBreadcrumb match={match} history={history} />
          <div className="default-header-buttons">
            <Button className="button-return" onClick={() => history.goBack()}>
              <Icon type="left" theme="outlined" className="default-back-icon" />
              {getMessage('back')}
            </Button>
            {hasAccess && (
              <Button
                type="primary"
                className="button-action"
                onClick={() => {
                  submitForm()
                }}
              >
                {id ? getMessage('update') : getMessage('register')}
              </Button>
            )}
          </div>
        </div>
      </div>
    )
  }

  function onChange(setFieldValue) {
    return (field, key) => {
      setFormValues({ ...formValues, [field]: key })
      return setFieldValue(field, key)
    }
  }

  // eslint-disable-next-line no-unused-vars
  function renderForm({ values, errors, handleBlur, handleSubmit, setFieldValue, submitForm }) {
    // Let documentTypeMask = getDocumentMask(values)
    const setFieldValueWithState = onChange(setFieldValue)
    return (
      <Form className="login-form" layout="vertical" onSubmit={handleSubmit}>
        {renderHeader(submitForm)}

        <Card className="ant-card gx-card ant-card-bordered">
          <Typography.Title className="default-header-title" level={3}>
            {getTitle()}
          </Typography.Title>
          <Row type="flex" justify="start">
            <CustomInput
              field="maps.lat"
              errors={errors}
              setFieldValue={setFieldValueWithState}
              rowSpan={5}
              value={formValues}
              handleBlur={(e) => {
                const v = e.target.value.replace(/[a-zA-Z]+/g, '')
                setMapLatitude(v)
                return e
              }}
            />
            <CustomInput
              field="maps.long"
              errors={errors}
              setFieldValue={setFieldValueWithState}
              rowSpan={5}
              value={formValues}
              handleBlur={(e) => {
                const v = e.target.value.replace(/[a-zA-Z]+/g, '')
                setMapLongitude(v)
              }}
            />
          </Row>
          <Row type="flex" justify="start">
            <Col span={24}>
              <Row type="flex" justify="start">
                <CustomMap
                  latitude={mapLatitude}
                  longitude={mapLongitude}
                  zoom={8}
                  setMapLatitude={setMapLatitude}
                  setMapLongitude={setMapLongitude}
                  setMapZoom={setMapZoom}
                />
              </Row>
            </Col>
          </Row>

          <FormHeader title={getMessage('tab.PersonalData')} orientation="left" type="horizontal" />
          <Row type="flex">
            <CustomSwitch
              field="active"
              errors={errors}
              setFieldValue={setFieldValueWithState}
              rowSpan={12}
              value={formValues}
              handleBlur={form.handleBlur}
              unCheckedChildren={getMessage('label.inactive')}
              checkedChildren={getMessage('label.active')}
              defaultValue={true}
            />
          </Row>
          <Row type="flex">
            <CustomInput
              field="name"
              errors={errors}
              setFieldValue={setFieldValueWithState}
              rowSpan={10}
              value={formValues}
              handleBlur={form.handleBlur}
            />
          </Row>
          <Row type="flex">
            <CustomSelect
              showSearch
              field="documentTypeId"
              errors={errors}
              setFieldValue={setFieldValueWithState}
              rowSpan={5}
              value={formValues}
              values={documentType}
              handleBlur={form.handleBlur}
            />
            <CustomInput
              field="documentNumber"
              errors={errors}
              setFieldValue={setFieldValueWithState}
              rowSpan={5}
              value={formValues}
              handleBlur={form.handleBlur}
              mask={documentTypeMask}
            />
          </Row>
          <Row type="flex">
            <CustomSelect
              showSearch
              field="memberTypeId"
              multiple
              errors={errors}
              setFieldValue={setFieldValueWithState}
              rowSpan={10}
              value={formValues}
              values={formatedMemberTypes}
            />
          </Row>
          <Row type="flex">
            <CustomInput
              field="emailAddress"
              errors={errors}
              setFieldValue={setFieldValueWithState}
              rowSpan={10}
              value={formValues}
              handleBlur={form.handleBlur}
            />
          </Row>
          <Row type="flex" justify="start">
            <CustomInput
              field="phoneNumber"
              errors={errors}
              setFieldValue={setFieldValueWithState}
              rowSpan={12}
              value={formValues}
              handleBlur={form.handleBlur}
              mask={'(11)11111-1111'}
            />
          </Row>
          <FormHeader title={getMessage('tab.accountData')} orientation="left" type="horizontal" />
          <Row type="flex">
            <CustomSwitch
              field="allowToLogin"
              errors={errors}
              setFieldValue={setFieldValueWithState}
              rowSpan={12}
              value={formValues}
              handleBlur={form.handleBlur}
              unCheckedChildren={getMessage('label.no')}
              checkedChildren={getMessage('label.yes')}
            />
          </Row>
          {formValues.allowToLogin && (
            <>
              <Row type="flex">
                <CustomInput
                  information={PasswordPopover}
                  icon={'info-circle'}
                  field="password"
                  errors={errors}
                  setFieldValue={setFieldValueWithState}
                  rowSpan={5}
                  value={formValues}
                  className="darck-input-password-icon"
                  handleBlur={form.handleBlur}
                  type="password"
                />
                <CustomInput
                  field="confirmPassword"
                  errors={errors}
                  setFieldValue={setFieldValueWithState}
                  rowSpan={5}
                  value={formValues}
                  className="darck-input-password-icon"
                  handleBlur={form.handleBlur}
                  type="password"
                />
              </Row>
              <Row>
                <CustomSelect
                  showSearch
                  field="profileId"
                  errors={errors}
                  setFieldValue={setFieldValueWithState}
                  rowSpan={10}
                  value={formValues}
                  values={formatedProfiles}
                  handleBlur={form.handleBlur}
                />
              </Row>
            </>
          )}

          <FormHeader title={getMessage('tab.address')} orientation="left" type="horizontal" />
          <Row type="flex">
            <CustomInput
              field="zipCode"
              errors={errors}
              setFieldValue={setFieldValueWithState}
              rowSpan={10}
              value={formValues}
              handleBlur={form.handleBlur}
              mask="11111-111"
            />
          </Row>
          <Row type="flex">
            <CustomInput
              field="addressDescription"
              errors={errors}
              setFieldValue={setFieldValueWithState}
              rowSpan={6}
              value={formValues}
              handleBlur={form.handleBlur}
            />
            <CustomInput
              field="addressNumber"
              errors={errors}
              setFieldValue={setFieldValueWithState}
              rowSpan={6}
              value={formValues}
              handleBlur={form.handleBlur}
            />
            <CustomInput
              field="addressComplement"
              errors={errors}
              setFieldValue={setFieldValueWithState}
              rowSpan={6}
              value={formValues}
              handleBlur={form.handleBlur}
            />
          </Row>
          <Row type="flex">
            <CustomInput
              field="neighborhood"
              errors={errors}
              setFieldValue={setFieldValueWithState}
              rowSpan={10}
              value={formValues}
              handleBlur={form.handleBlur}
            />
            <CustomSelect
              showSearch
              field="state"
              errors={errors}
              setFieldValue={setFieldValueWithState}
              rowSpan={5}
              value={formValues}
              values={formattedStates}
            />
            <CustomSelect
              showSearch
              field="cityStateId"
              errors={errors}
              setFieldValue={setFieldValueWithState}
              rowSpan={5}
              value={formValues}
              values={formatedCities}
            />
            <CustomSelect
              showSearch
              multiple
              field="organizations"
              errors={errors}
              setFieldValue={setFieldValueWithState}
              rowSpan={6}
              value={values}
              values={formattedOrganizations}
              onChange={onChangeOrganization}
            />
            <CustomSelect
              showSearch
              multiple
              field="regions"
              errors={errors}
              setFieldValue={setFieldValueWithState}
              rowSpan={6}
              value={values}
              values={formattedRegions}
              onChange={onChangeRegion}
              enable={formValues?.organizations?.length === 0}
            />
            <CustomSelect
              showSearch
              multiple
              field="districts"
              errors={errors}
              setFieldValue={setFieldValueWithState}
              rowSpan={6}
              value={values}
              values={formattedDistricts}
              enable={formValues?.regions?.length === 0}
            />
          </Row>
        </Card>
      </Form>
    )
  }
  return (
    <Formik
      enableReinitialize
      validationSchema={form.validationSchema}
      initialValues={form.initialValues}
      onSubmit={(values, { setSubmitting, setFieldError, resetForm }) =>
        form.onSubmit(values, setSubmitting, setFieldError, resetForm)
      }
      validateOnChange={false}
      validateOnBlur={false}
    >
      {(formikProps) => {
        injectValidationMethods(formikProps.values, form.validationSchema)
        return renderForm(formikProps)
      }}
    </Formik>
  )
}

export default CreateMember
